/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var SLEEP_PDF_VARIANT_ID = 57550168129909;
  var syncInProgress = false;
  var pendingSync = null;

  function cartEndpoint(path) {
    var root = window.theme && window.theme.routes && window.theme.routes.root ? window.theme.routes.root : '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function fetchCart() {
    return fetch(cartEndpoint('cart.js'), {
      headers: {
        Accept: 'application/json'
      }
    }).then(function(response) {
      return response.json();
    });
  }

  function changePdfQuantity(quantity) {
    return fetch(cartEndpoint('cart/update.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates: (function() {
          var updates = {};
          updates[SLEEP_PDF_VARIANT_ID] = quantity;
          return updates;
        })()
      })
    }).then(function(response) {
      return response.json();
    });
  }

  function addPdfGift() {
    return fetch(cartEndpoint('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: SLEEP_PDF_VARIANT_ID,
        quantity: 1,
        properties: {
          _auto_free_pdf: 'true'
        }
      })
    }).then(function(response) {
      return response.json();
    });
  }

  function refreshCartUi() {
    if (window.cart && typeof window.cart.getCart === 'function') {
      window.cart.getCart();
      return;
    }

    if (document.body && document.body.classList.contains('template-cart')) {
      window.location.reload();
    }
  }

  function ensureSleepPdfGift() {
    if (syncInProgress) {
      window.clearTimeout(pendingSync);
      pendingSync = window.setTimeout(ensureSleepPdfGift, 250);
      return;
    }

    syncInProgress = true;

    fetchCart()
      .then(function(cart) {
        var pdfItems = cart.items.filter(function(item) {
          return Number(item.variant_id) === SLEEP_PDF_VARIANT_ID;
        });
        var paidItems = cart.items.filter(function(item) {
          return Number(item.variant_id) !== SLEEP_PDF_VARIANT_ID;
        });
        var paidQty = paidItems.reduce(function(total, item) {
          return total + item.quantity;
        }, 0);
        var pdfQty = pdfItems.reduce(function(total, item) {
          return total + item.quantity;
        }, 0);

        if (paidQty === 0 && pdfQty > 0) {
          return changePdfQuantity(0).then(refreshCartUi);
        }

        if (paidQty > 0 && pdfQty === 0) {
          return addPdfGift().then(refreshCartUi);
        }

        if (paidQty > 0 && pdfQty > 1) {
          return changePdfQuantity(1).then(refreshCartUi);
        }
      })
      .catch(function(error) {
        console.warn('DREAMSILK free sleep PDF sync failed', error);
      })
      .finally(function() {
        syncInProgress = false;
      });
  }

  function scheduleSleepPdfGiftSync() {
    window.clearTimeout(pendingSync);
    pendingSync = window.setTimeout(ensureSleepPdfGift, 350);
  }

  document.addEventListener('DOMContentLoaded', scheduleSleepPdfGiftSync);
  document.addEventListener('theme:product:added', scheduleSleepPdfGiftSync);
  document.addEventListener('theme:cart:change', scheduleSleepPdfGiftSync);

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (form && form.matches('form[action*="/cart/add"]')) {
      scheduleSleepPdfGiftSync();
    }
  }, true);


  



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
